import './NavbarLink.css'
import cx from 'classnames'
import { NavLink } from 'react-router-dom'
import { motion } from 'motion/react'
import { useState } from 'react'

export function NavbarLink({
  to,
  children,
  disabled,
  onClickDisabled
}: {
  to: string
  children: React.ReactNode
  disabled?: boolean
  onClickDisabled?: (evt: React.MouseEvent) => void
}) {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <NavLink
      to={to}
      data-disabled={disabled}
      onClick={evt => {
        if (disabled) {
          evt.preventDefault()

          if (onClickDisabled) {
            onClickDisabled(evt)
          }
        }
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={cx('navbar-link', 'navbar-link-disabled')}
    >
      {({ isActive }) => (
        <>
          <span className="navbar-link-content">{children}</span>
          <motion.span
            className="navbar-link-underline"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: isHovered && !disabled && !isActive ? 1 : 0 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
          />
        </>
      )}
    </NavLink>
  )
}
